/**
 * pricing.ts — Canonical ɳSentry pricing constants
 *
 * Source of truth: SPORT F07-PRICING-TIERS.md
 * Updated: 2026-04-22 (user-canonical — supersedes all prior pricing)
 *
 * Never hand-edit prices on the frontend — edit SPORT F07 + re-run sync-sport.
 */

export interface BundlePrice {
  monthly: number
  annual: number
  /** Approximate annual savings vs monthly ×12 */
  annualSavingsPct: number
}

export interface Tier {
  id: string
  name: string
  price: BundlePrice | null
  description: string
  highlighted?: boolean
}

/** ɳSentry Bundle pricing — SPORT F07 canonical */
export const NSENTRY_BUNDLE: BundlePrice = {
  monthly: 0.99,
  annual: 9.99,
  annualSavingsPct: 16,
}

/** ɳSelf+ (all bundles) pricing — SPORT F07 canonical */
export const NSELF_PLUS: BundlePrice = {
  monthly: 3.99,
  annual: 39.99,
  annualSavingsPct: 16,
}

/** Pricing tiers for the ɳSentry pricing page */
export const PRICING_TIERS: Tier[] = [
  {
    id: 'free',
    name: 'Free',
    price: null,
    description: 'Core nSelf CLI + 31 free plugins. Infrastructure monitoring (Prometheus, Grafana, Loki) included.',
  },
  {
    id: 'nsentry',
    name: 'ɳSentry Bundle',
    price: NSENTRY_BUNDLE,
    description: 'All 13 ɳSentry plugins on your ɳSelf instance. Backend-only — no companion app needed.',
    highlighted: true,
  },
  {
    id: 'plus',
    name: 'ɳSelf+',
    price: NSELF_PLUS,
    description: 'All 6 paid bundles + all apps + support via chat.nself.org or the ɳChat app.',
  },
]

/** Format a price for display, e.g. "$0.99" */
export function formatPrice(price: number): string {
  return `$${price.toFixed(2)}`
}
